import React from 'react';
import AdditionalData from "./AdditionalData";
import Details from './Details';
import Activity from '@/react/pages/download_log/components/Activity'

const DynamicLog = ({ data }) => {
	if (data.type === 'quick_apply')
		return <AdditionalData data={data} />
	else if (data.type=="download" || data.type=="authentication")
		return <Activity data={data} />

	return <Details classList="text-black log-text" data={data} />
}

export default DynamicLog;